<template>
    <div id="login">
        <h1>Login</h1>
        <form method="post" action="/api/login">
            <input type="text" name="username" v-model="input.username" placeholder="Username" />
            <input type="password" name="password" v-model="input.password" placeholder="Password" />
            <button type="submit">Login</button>
        </form>
    </div>
</template>

<script>
    import * as api from '@/api'

    export default {
        name: 'Login',
        data() {
            return {
                input: {
                    username: "",
                    password: ""
                }
            }
        },
        methods: {
        },
        created() {
            api.getUser()
                .then(()=>{
                    this.$router.replace({name: "DevicesList"});
                })
                .catch(err=>{})
        }
    }
</script>

<style scoped>
    #login {
        width: 500px;
        border: 1px solid #CCCCCC;
        background-color: #FFFFFF;
        margin: auto;
        margin-top: 50px;
        padding: 20px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Login.vue